import { RequestInputOutputParamsModel } from "../models/requestInputOutputParams.model";
import { HttpService } from "./http.service";

const basePath = "/EquipmentData";
const request = HttpService.handleRequest();

export const EquipmentDataService = {
  getByEquipment,
  getPaginatedList,
  deleteByProc,
  restoreByProc
};

async function getByEquipment(id: any) {
  return request.get(`${basePath}/GetByEquipmentId/${id}`);
}

async function getPaginatedList(data: RequestInputOutputParamsModel) {
  return request.post(`${basePath}/ListWithPagination`, data);
}

async function deleteByProc(data: RequestInputOutputParamsModel) {
  return request.post(`${basePath}/DeleteByProc`, data);
}

async function restoreByProc(data: RequestInputOutputParamsModel) {
  return request.post(`${basePath}/RestoreByProc`, data);
}

export default EquipmentDataService;